import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Card } from 'react-bootstrap';

function AssessmentFallback({
  message
}: {
  message: string | React.ReactNode;
}) {
  return (
    <div className="w-100 d-flex justify-content-center align-items-center">
      <Card>
        <Card.Body>
          <div className="text-body-tertiary text-opacity-85 fs-7">
            <FontAwesomeIcon icon={faCircleInfo} />
            <span className="ms-2">{message}</span>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}

export default AssessmentFallback;
